<label class="mat-optgroup-label" [id]="_labelId">{{ label }} <ng-content></ng-content></label>
<ng-content select="mat-option, ng-container"></ng-content>
